import { all, fork } from 'redux-saga/effects';

import requestTasksSagas from './requestTasks/sagas';

export default function* sagas() {
  yield all([fork(requestTasksSagas)]);
}
